module.exports = __webpack_public_path__ + "img/freestyle_box26.5984e31e.jpg";